import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import { STATUS_COLORS, STATUS_LABELS, TYPE_LABELS } from "../web/constants";

export default function MobileDashboardLatestLeaves({ latestLeaves, leaveStats }) {
    return (
        <Card
            sx={{
                borderRadius: "16px",
                background:
                    "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(245,248,255,0.92) 50%, rgba(255,255,255,0.94) 100%)",
                backdropFilter: "blur(12px)",
                border: "1px solid rgba(148,163,184,0.28)",
                boxShadow: "0 8px 32px rgba(15, 23, 42, 0.10)",
                overflow: "hidden",
                position: "relative",
            }}
        >
            {/* Orange accent bar */}
            <Box
                sx={{
                    height: 4,
                    background:
                        "linear-gradient(90deg, #FF9015, rgba(255,193,0,0.85), #FF9015)",
                }}
            />

            <CardContent sx={{ p: 2, position: "relative" }}>
                {/* Header */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: "1rem",
                            letterSpacing: "-0.01em",
                            color: "rgba(15, 23, 42, 0.9)",
                        }}
                    >
                        Dernières demandes
                    </Typography>
                    <Chip
                        label={`${leaveStats?.total ?? 0} total`}
                        size="small"
                        variant="outlined"
                        sx={{
                            borderColor: "rgba(255, 144, 21, 0.35)",
                            color: "#FF9015",
                            fontWeight: 600,
                            fontSize: "0.72rem",
                            letterSpacing: "0.02em",
                            background: "rgba(255, 144, 21, 0.06)",
                        }}
                    />
                </Stack>

                <Divider
                    sx={{
                        my: 1.5,
                        borderColor: "rgba(148, 163, 184, 0.22)",
                    }}
                />

                {/* Leave list */}
                <Stack spacing={0.5}>
                    {latestLeaves?.length ? (
                        latestLeaves.map((leave, index) => (
                            <Box
                                key={`${leave.id ?? "leave"}-${leave.from ?? "from"}-${leave.to ?? "to"}-${index}`}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.75,
                                    px: 1.5,
                                    py: 1.25,
                                    borderRadius: "12px",
                                    transition:
                                        "background 200ms ease, transform 150ms ease",
                                    cursor: "default",
                                    userSelect: "none",
                                    WebkitTapHighlightColor: "transparent",
                                    "&:active": {
                                        transform: "scale(0.97)",
                                        background: "rgba(255, 144, 21, 0.06)",
                                    },
                                }}
                            >
                                {/* Name */}
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "0.875rem",
                                        color: "rgba(15, 23, 42, 0.88)",
                                        letterSpacing: "-0.005em",
                                        lineHeight: 1.3,
                                    }}
                                >
                                    {leave.prenom} {leave.nom}
                                </Typography>

                                {/* Date range */}
                                <Typography
                                    sx={{
                                        color: "rgba(100, 116, 139, 0.85)",
                                        fontSize: "0.78rem",
                                        fontWeight: 400,
                                    }}
                                >
                                    {leave.from} - {leave.to}
                                </Typography>

                                {/* Chips */}
                                <Stack
                                    direction="row"
                                    spacing={0.75}
                                    alignItems="center"
                                    sx={{ mt: 0.25 }}
                                >
                                    <Chip
                                        label={
                                            TYPE_LABELS[leave.type] ||
                                            leave.type
                                        }
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                            fontSize: "0.7rem",
                                            fontWeight: 500,
                                            height: 26,
                                            borderColor:
                                                "rgba(148, 163, 184, 0.35)",
                                        }}
                                    />
                                    <Chip
                                        label={
                                            STATUS_LABELS[leave.status] ||
                                            leave.status
                                        }
                                        size="small"
                                        color={
                                            STATUS_COLORS[leave.status] ||
                                            "default"
                                        }
                                        sx={{
                                            fontSize: "0.7rem",
                                            fontWeight: 600,
                                            height: 26,
                                        }}
                                    />
                                </Stack>
                            </Box>
                        ))
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{
                                color: "rgba(100, 116, 139, 0.7)",
                                fontStyle: "italic",
                                py: 3,
                                textAlign: "center",
                            }}
                        >
                            Aucune demande récente.
                        </Typography>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
}
